var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6988 3.57369L4.69875 9.57369C4.64602 9.62636 4.57453 9.65595 4.5 9.65595C4.42547 9.65595 4.35399 9.62636 4.30125 9.57369L1.67625 6.94869C1.62657 6.89538 1.59953 6.82486 1.60081 6.752C1.6021 6.67913 1.63162 6.60961 1.68315 6.55808C1.73468 6.50655 1.80419 6.47704 1.87706 6.47575C1.94992 6.47447 2.02044 6.50151 2.07375 6.55119L4.5 8.97697L10.3013 3.17619C10.3546 3.12651 10.4251 3.09947 10.4979 3.10075C10.5708 3.10204 10.6403 3.13155 10.6919 3.18308C10.7434 3.23461 10.7729 3.30413 10.7742 3.377C10.7755 3.44986 10.7484 3.52038 10.6988 3.57369Z",
    fill: "#326164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0c44e3d172b48391280490bb48a436ab.svg";
export { ForwardRef as ReactComponent };